import { createAction, props } from '@ngrx/store'
import { Address } from '../user-profile/user-profile.state'

export enum AddressTypes {
  SET_ADDRESS_TO_EDIT = '[ADDRESS] Set Address To Edit',
}

export const AddressActions = {
  setAddressToEdit: createAction(AddressTypes.SET_ADDRESS_TO_EDIT, props<{ payload: Address }>()),
}
